import PublicPageWrapper from './PublicPageWrapper';

export { default as PublicPageFormPaper } from './PublicPageFormPaper';
export default PublicPageWrapper;
